
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stations/[slug]",
      function () {
        return require("private-next-pages/stations/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stations/[slug]"])
      });
    }
  